module.exports = __webpack_public_path__ + "media/images/location-1cd2d4863e27c900dc60cc8f9fbd6ea5.svg";